import React, { useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DANHMUCVANBANGCHUNGCHI_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import { useMutation } from 'react-query';

const schema = yup.object().shape({
    ten: yup.string().required(messageError.emptyMessage).max(255, 'Tên không được vượt quá 255 ký tự')
});

const DanhMucVanBangChungChiAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(DANHMUCVANBANGCHUNGCHI_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = {
            ...values,
            doiTuongApDung: values.doiTuongApDung ? Number(values.doiTuongApDung) : null
        };

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới danh mục văn bằng chứng chỉ</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        ten: '',
                        doiTuongApDung: 0,
                        isActive: true
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            {/* Trường Tên giữ nguyên */}
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên',
                                        name: 'ten',
                                        value: values.ten,
                                        onChange: handleChange,
                                        isInvalid: errors.ten,
                                        error: errors.ten
                                    }
                                ]}
                            />

                            {/* Trường Đối tượng áp dụng chuyển thành Select */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={2}>
                                    Đối tượng áp dụng
                                </Form.Label>
                                <Col md={10}>
                                    <Form.Control
                                        as="select"
                                        name="doiTuongApDung"
                                        value={values.doiTuongApDung}
                                        // Formik đôi khi nhận value từ select là string, bạn có thể cần ép kiểu sang Number khi submit
                                        onChange={handleChange}
                                        isInvalid={!!errors.doiTuongApDung}
                                    >
                                        <option value="">-- Chọn đối tượng --</option>
                                        {/* Đổi value thành các giá trị tương ứng với Enum ở Backend */}
                                        <option value={1}>Bác sĩ</option>
                                        <option value={2}>Điều dưỡng</option>
                                        <option value={3}>Kỹ thuật viên</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.doiTuongApDung}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default DanhMucVanBangChungChiAdd;